import { render, staticRenderFns } from "./OlvidoPass.vue?vue&type=template&id=c2979282"
import script from "./OlvidoPass.vue?vue&type=script&lang=js"
export * from "./OlvidoPass.vue?vue&type=script&lang=js"
import style0 from "./OlvidoPass.vue?vue&type=style&index=0&id=c2979282&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports